export default __webpack_public_path__ + "static/media/uploadicon2.31ef60fe.svg";